import {
  MFAActions,
  MFAChannel,
  PreferenceSelectorState,
  Selectors,
  useWidgetDispatch,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library';
import {useEffect, useMemo} from 'react';
import {useLocation, useSearchParams} from 'react-router-dom';
import {redirectWithForwardUrl} from 'utils/utils';

import ConnectedAddContactInfo from 'containers/AddContactInfo';
import {useGetForwardUrl} from 'hooks/useGetFowardUrl';

/**
 * This is the screen where user can add/edit either phone or email
 * And will be asked to verify those
 */
const VerifyIdentity: React.FunctionComponent = () => {
  const [searchParams] = useSearchParams();
  const {state} = useLocation();
  const action = searchParams.get('action') ?? state?.action;
  const dispatch = useWidgetDispatch();
  const preferenceSelectorState = useWidgetState(
    Selectors.preferenceSelectorStateSelector,
  );
  const forwardUrl = useGetForwardUrl();

  const channel = useMemo(() => {
    switch (preferenceSelectorState) {
      case PreferenceSelectorState.AddEmail:
      case PreferenceSelectorState.EditEmail:
        return MFAChannel.EMAIL;

      case PreferenceSelectorState.AddPhone:
      case PreferenceSelectorState.EditPhone:
        return MFAChannel.SMS;
      default:
        return MFAChannel.EMAIL;
    }
  }, [preferenceSelectorState]);

  useEffect(() => {
    /**
     * Set the state if it's not already set
     * For example when user comes to this screen from another app
     */
    if (
      preferenceSelectorState === PreferenceSelectorState.Initial &&
      action &&
      action in PreferenceSelectorState
    ) {
      dispatch(MFAActions.setPreferenceSelectorState(action));
    }
  }, [action, dispatch, preferenceSelectorState]);

  // if there is no selector state and no action, then direct user to forwardUrl
  if (
    preferenceSelectorState === PreferenceSelectorState.Initial &&
    (!action || !(action in PreferenceSelectorState))
  ) {
    redirectWithForwardUrl(forwardUrl);
    return null;
  }

  return <ConnectedAddContactInfo channel={channel} />;
};

export default VerifyIdentity;
